/**
 * Date (YYYY-MM-DD) dei turni da generare tra `dataDal` e `dataAl` (inclusi).
 *
 * Tutto in ora locale: mischiare UTC e ora locale sposta le date di un giorno
 * quando l'intervallo attraversa il cambio dell'ora legale.
 *
 * @param giorniSettimana giorni ammessi come Date.getDay() (0 = domenica); ignorato se singleDay.
 */
export const generaDateTurni = (
    dataDal: string,
    dataAl: string,
    giorniSettimana: number[],
    singleDay: boolean,
): string[] => {
    const parse = (s: string): Date | null => {
        const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s || '');
        return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
    };
    const pad = (n: number) => String(n).padStart(2, '0');
    const fmt = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

    const cur = parse(dataDal);
    const end = parse(dataAl);
    if (!cur || !end) return [];
    const out: string[] = [];
    while (cur <= end) {
        if (singleDay || giorniSettimana.includes(cur.getDay())) out.push(fmt(cur));
        cur.setDate(cur.getDate() + 1);
    }
    return out;
};
